export default [
  // Region code for global networks (e.g. +800 numbers).
  // { code: '001', name: 'Global networks', dial_code: '' },
  // { code: 'AC', name: 'Ascension Island', dial_code: '' },
  { code: 'AD', name: 'Andorra', dial_code: '' },
  { code: 'AE', name: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)', dial_code: '' },
  { code: 'AF', name: 'Afghanistan (‫افغانستان‬‎)', dial_code: '' },
  { code: 'AG', name: 'Antigua and Barbuda', dial_code: '' },
  { code: 'AI', name: 'Anguilla', dial_code: '' },
  { code: 'AL', name: 'Albania (Shqipëri)', dial_code: '' },
  { code: 'AM', name: 'Armenia (Հայաստան)', dial_code: '' },
  { code: 'AO', name: 'Angola', dial_code: '' },
  { code: 'AR', name: 'Argentina', dial_code: '' },
  { code: 'AS', name: 'American Samoa (Amerika Sāmoa)', dial_code: '' },
  { code: 'AT', name: 'Austria (Österreich)', dial_code: '' },
  { code: 'AU', name: 'Australia', dial_code: '' },
  { code: 'AW', name: 'Aruba', dial_code: '' },
  { code: 'AX', name: 'Åland Islands', dial_code: '' },
  { code: 'AZ', name: 'Azerbaijan (Azərbaycan)', dial_code: '' },
  { code: 'BA', name: 'Bosnia and Herzegovina', dial_code: '' },
  { code: 'BB', name: 'Barbados', dial_code: '' },
  { code: 'BD', name: 'Bangladesh (বাংলাদেশ)', dial_code: '' },
  { code: 'BE', name: 'Belgium (België)', dial_code: '' },
  { code: 'BF', name: 'Burkina Faso', dial_code: '' },
  { code: 'BG', name: 'Bulgaria (България)', dial_code: '' },
  { code: 'BH', name: 'Bahrain (‫البحرين‬‎)', dial_code: '' },
  { code: 'BI', name: 'Burundi (Uburundi)', dial_code: '' },
  { code: 'BJ', name: 'Benin (Bénin)', dial_code: '' },
  { code: 'BL', name: 'Saint Barthélemy (Saint-Barthélemy)', dial_code: '' },
  { code: 'BM', name: 'Bermuda', dial_code: '' },
  { code: 'BN', name: 'Brunei (Negara Brunei Darussalam)', dial_code: '' },
  { code: 'BO', name: 'Bolivia', dial_code: '' },
  { code: 'BQ', name: 'Caribbean Netherlands', dial_code: '' },
  { code: 'BR', name: 'Brazil (Brasil)', dial_code: '' },
  { code: 'BS', name: 'Bahamas', dial_code: '' },
  { code: 'BT', name: 'Bhutan (འབྲུག)', dial_code: '' },
  { code: 'BW', name: 'Botswana', dial_code: '' },
  { code: 'BY', name: 'Belarus (Беларусь)', dial_code: '' },
  { code: 'BZ', name: 'Belize', dial_code: '' },
  { code: 'CA', name: 'Canada', dial_code: '' },
  { code: 'CC', name: 'Cocos (Keeling) Islands', dial_code: '' },
  { code: 'CD', name: 'Congo (DRC) (Kongo)', dial_code: '' },
  { code: 'CF', name: 'Central African Republic', dial_code: '' },
  { code: 'CG', name: 'Congo (Republic) (Congo-Brazzaville)', dial_code: '' },
  { code: 'CH', name: 'Switzerland (Schweiz)', dial_code: '' },
  { code: 'CI', name: 'Côte d’Ivoire', dial_code: '' },
  { code: 'CK', name: 'Cook Islands', dial_code: '' },
  { code: 'CL', name: 'Chile', dial_code: '' },
  { code: 'CM', name: 'Cameroon (Cameroun)', dial_code: '' },
  { code: 'CN', name: 'China (中国)', dial_code: '' },
  { code: 'CO', name: 'Colombia', dial_code: '' },
  { code: 'CR', name: 'Costa Rica', dial_code: '' },
  { code: 'CU', name: 'Cuba', dial_code: '' },
  { code: 'CV', name: 'Cape Verde (Kabu Verdi)', dial_code: '' },
  { code: 'CW', name: 'Curaçao', dial_code: '' },
  { code: 'CX', name: 'Christmas Island', dial_code: '' },
  { code: 'CY', name: 'Cyprus (Κύπρος)', dial_code: '' },
  { code: 'CZ', name: 'Czech Republic (Česká republika)', dial_code: '' },
  { code: 'DE', name: 'Germany (Deutschland)', dial_code: '' },
  { code: 'DJ', name: 'Djibouti', dial_code: '' },
  { code: 'DK', name: 'Denmark (Danmark)', dial_code: '' },
  { code: 'DM', name: 'Dominica', dial_code: '' },
  { code: 'DO', name: 'Dominican Republic', dial_code: '' },
  { code: 'DZ', name: 'Algeria (‫الجزائر‬‎)', dial_code: '' },
  { code: 'EC', name: 'Ecuador', dial_code: '' },
  { code: 'EE', name: 'Estonia (Eesti)', dial_code: '' },
  { code: 'EG', name: 'Egypt (‫مصر‬‎)', dial_code: '' },
  { code: 'EH', name: 'Western Sahara (‫الصحراء الغربية‬‎)', dial_code: '' },
  { code: 'ER', name: 'Eritrea', dial_code: '' },
  { code: 'ES', name: 'Spain (España)', dial_code: '' },
  { code: 'ET', name: 'Ethiopia', dial_code: '' },
  { code: 'FI', name: 'Finland (Suomi)', dial_code: '' },
  { code: 'FJ', name: 'Fiji (Matanitu Tugalala o Viti)', dial_code: '' },
  { code: 'FK', name: 'Falkland Islands (Islas Malvinas)', dial_code: '' },
  { code: 'FM', name: 'Micronesia', dial_code: '' },
  { code: 'FO', name: 'Faroe Islands (Føroyar)', dial_code: '' },
  { code: 'FR', name: 'France (République française)', dial_code: '' },
  { code: 'GA', name: 'Gabon (République gabonaise)', dial_code: '' },
  { code: 'GB', name: 'United Kingdom', dial_code: '' },
  { code: 'GD', name: 'Grenada', dial_code: '' },
  { code: 'GE', name: 'Georgia (საქართველო)', dial_code: '' },
  { code: 'GF', name: 'French Guiana (Guyane française)', dial_code: '' },
  { code: 'GG', name: 'Guernsey', dial_code: '' },
  { code: 'GH', name: 'Ghana (Gaana)', dial_code: '' },
  { code: 'GI', name: 'Gibraltar', dial_code: '' },
  { code: 'GL', name: 'Greenland (Kalaallit Nunaat)', dial_code: '' },
  { code: 'GM', name: 'Gambia', dial_code: '' },
  { code: 'GN', name: 'Guinea (Guinée)', dial_code: '' },
  { code: 'GP', name: 'Guadeloupe', dial_code: '' },
  { code: 'GQ', name: 'Equatorial Guinea (Guinea Ecuatorial)', dial_code: '' },
  { code: 'GR', name: 'Greece (Ελλάδα)', dial_code: '' },
  { code: 'GT', name: 'Guatemala', dial_code: '' },
  { code: 'GU', name: 'Guam (Guåhån)', dial_code: '' },
  { code: 'GW', name: 'Guinea-Bissau (Guiné Bissau)', dial_code: '' },
  { code: 'GY', name: 'Guyana', dial_code: '' },
  { code: 'HK', name: 'Hong Kong (香港)', dial_code: '' },
  { code: 'HN', name: 'Honduras', dial_code: '' },
  { code: 'HR', name: 'Croatia (Hrvatska)', dial_code: '' },
  { code: 'HT', name: 'Haiti (République d\'Haïti)', dial_code: '' },
  { code: 'HU', name: 'Hungary (Magyarország)', dial_code: '' },
  { code: 'ID', name: 'Indonesia', dial_code: '' },
  { code: 'IE', name: 'Ireland', dial_code: '' },
  { code: 'IL', name: 'Israel (‫ישראל‬‎)', dial_code: '' },
  { code: 'IM', name: 'Isle of Man', dial_code: '' },
  { code: 'IN', name: 'India (भारत)', dial_code: '' },
  { code: 'IO', name: 'British Indian Ocean Territory', dial_code: '' },
  { code: 'IQ', name: 'Iraq (‫العراق‬‎)', dial_code: '' },
  { code: 'IR', name: 'Iran (‫ایران‬‎)', dial_code: '' },
  { code: 'IS', name: 'Iceland (Ísland)', dial_code: '' },
  { code: 'IT', name: 'Italy (Italia)', dial_code: '' },
  { code: 'JE', name: 'Jersey', dial_code: '' },
  { code: 'JM', name: 'Jamaica', dial_code: '' },
  { code: 'JO', name: 'Jordan (‫الأردن‬‎)', dial_code: '' },
  { code: 'JP', name: 'Japan (日本)', dial_code: '' },
  { code: 'KE', name: 'Kenya', dial_code: '' },
  { code: 'KG', name: 'Kyrgyzstan (Кыргызстан)', dial_code: '' },
  { code: 'KH', name: 'Cambodia (កម្ពុជា)', dial_code: '' },
  { code: 'KI', name: 'Kiribati', dial_code: '' },
  { code: 'KM', name: 'Comoros (‫جزر القمر‬‎)', dial_code: '' },
  { code: 'KN', name: 'Saint Kitts and Nevis', dial_code: '' },
  { code: 'KP', name: 'North Korea (조선 민주주의 인민 공화국)', dial_code: '' },
  { code: 'KR', name: 'South Korea (대한민국)', dial_code: '' },
  { code: 'KW', name: 'Kuwait (‫الكويت‬‎)', dial_code: '' },
  { code: 'KY', name: 'Cayman Islands', dial_code: '' },
  { code: 'KZ', name: 'Kazakhstan (Казахстан)', dial_code: '' },
  { code: 'LA', name: 'Laos (ລາວ)', dial_code: '' },
  { code: 'LB', name: 'Lebanon (‫لبنان‬‎)', dial_code: '' },
  { code: 'LC', name: 'Saint Lucia', dial_code: '' },
  { code: 'LI', name: 'Liechtenstein', dial_code: '' },
  { code: 'LK', name: 'Sri Lanka (ශ්‍රී ලංකාව)', dial_code: '' },
  { code: 'LR', name: 'Liberia', dial_code: '' },
  { code: 'LS', name: 'Lesotho', dial_code: '' },
  { code: 'LT', name: 'Lithuania (Lietuva)', dial_code: '' },
  { code: 'LU', name: 'Luxembourg (Lëtzebuerg)', dial_code: '' },
  { code: 'LV', name: 'Latvia (Latvija)', dial_code: '' },
  { code: 'LY', name: 'Libya (‫ليبيا‬‎)', dial_code: '' },
  { code: 'MA', name: 'Morocco (‫المغرب‬‎)', dial_code: '' },
  { code: 'MC', name: 'Monaco', dial_code: '' },
  { code: 'MD', name: 'Moldova (Republica Moldova)', dial_code: '' },
  { code: 'ME', name: 'Montenegro (Crna Gora)', dial_code: '' },
  { code: 'MF', name: 'Saint Martin (Saint-Martin)', dial_code: '' },
  { code: 'MG', name: 'Madagascar (Madagasikara)', dial_code: '' },
  { code: 'MH', name: 'Marshall Islands', dial_code: '' },
  { code: 'MK', name: 'Macedonia (FYROM) (Македонија)', dial_code: '' },
  { code: 'ML', name: 'Mali', dial_code: '' },
  { code: 'MM', name: 'Myanmar (Burma) (မြန်မာ)', dial_code: '' },
  { code: 'MN', name: 'Mongolia (Монгол)', dial_code: '' },
  { code: 'MO', name: 'Macau (澳門)', dial_code: '' },
  { code: 'MP', name: 'Northern Mariana Islands', dial_code: '' },
  { code: 'MQ', name: 'Martinique', dial_code: '' },
  { code: 'MR', name: 'Mauritania (‫موريتانيا‬‎)', dial_code: '' },
  { code: 'MS', name: 'Montserrat', dial_code: '' },
  { code: 'MT', name: 'Malta', dial_code: '' },
  { code: 'MU', name: 'Mauritius (Moris)', dial_code: '' },
  { code: 'MV', name: 'Maldives', dial_code: '' },
  { code: 'MW', name: 'Malawi (Malaŵi)', dial_code: '' },
  { code: 'MX', name: 'Mexico (México)', dial_code: '' },
  { code: 'MY', name: 'Malaysia', dial_code: '' },
  { code: 'MZ', name: 'Mozambique (Moçambique)', dial_code: '' },
  { code: 'NA', name: 'Namibia (Namibië)', dial_code: '' },
  { code: 'NC', name: 'New Caledonia (Nouvelle-Calédonie)', dial_code: '' },
  { code: 'NE', name: 'Niger (Nijar)', dial_code: '' },
  { code: 'NF', name: 'Norfolk Island', dial_code: '' },
  { code: 'NG', name: 'Nigeria', dial_code: '' },
  { code: 'NI', name: 'Nicaragua', dial_code: '' },
  { code: 'NL', name: 'Netherlands (Nederland)', dial_code: '' },
  { code: 'NO', name: 'Norway (Norge)', dial_code: '' },
  { code: 'NP', name: 'Nepal (नेपाल)', dial_code: '' },
  { code: 'NR', name: 'Nauru (Repubrikin Naoero)', dial_code: '' },
  { code: 'NU', name: 'Niue (Niuē)', dial_code: '' },
  { code: 'NZ', name: 'New Zealand', dial_code: '' },
  { code: 'OM', name: 'Oman (‫عُمان‬‎)', dial_code: '' },
  { code: 'PA', name: 'Panama (Panamá)', dial_code: '' },
  { code: 'PE', name: 'Peru (Perú)', dial_code: '' },
  { code: 'PF', name: 'French Polynesia (Polynésie française)', dial_code: '' },
  { code: 'PG', name: 'Papua New Guinea', dial_code: '' },
  { code: 'PH', name: 'Philippines (Republika ng Pilipinas)', dial_code: '' },
  { code: 'PK', name: 'Pakistan (‫پاکستان‬‎)', dial_code: '' },
  { code: 'PL', name: 'Poland (Polska)', dial_code: '+48' },
  { code: 'PM', name: 'Saint Pierre and Miquelon', dial_code: '' },
  { code: 'PR', name: 'Puerto Rico', dial_code: '' },
  { code: 'PS', name: 'Palestine (‫فلسطين‬‎)', dial_code: '' },
  { code: 'PT', name: 'Portugal (República Portuguesa)', dial_code: '' },
  { code: 'PW', name: 'Palau (Beluu er a Belau)', dial_code: '' },
  { code: 'PY', name: 'Paraguay (Tetã Paraguái)', dial_code: '' },
  { code: 'QA', name: 'Qatar (‫قطر‬‎)', dial_code: '' },
  { code: 'RE', name: 'Réunion (La Réunion)', dial_code: '' },
  { code: 'RO', name: 'Romania (România)', dial_code: '' },
  { code: 'RS', name: 'Serbia (Србија)', dial_code: '' },
  { code: 'RU', name: 'Russia (Россия)', dial_code: '' },
  { code: 'RW', name: 'Rwanda', dial_code: '' },
  { code: 'SA', name: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)', dial_code: '' },
  { code: 'SB', name: 'Solomon Islands', dial_code: '' },
  { code: 'SC', name: 'Seychelles (Repiblik Sesel)', dial_code: '' },
  { code: 'SD', name: 'Sudan (‫السودان‬‎)', dial_code: '' },
  { code: 'SE', name: 'Sweden (Sverige)', dial_code: '+46' },
  { code: 'SG', name: 'Singapore (Singapura) (新加坡共和国)', dial_code: '' },
  { code: 'SH', name: 'Saint Helena', dial_code: '' },
  { code: 'SI', name: 'Slovenia (Slovenija)', dial_code: '' },
  { code: 'SJ', name: 'Svalbard and Jan Mayen', dial_code: '' },
  { code: 'SK', name: 'Slovakia (Slovensko)', dial_code: '' },
  { code: 'SL', name: 'Sierra Leone', dial_code: '' },
  { code: 'SM', name: 'San Marino', dial_code: '' },
  { code: 'SN', name: 'Senegal (Sénégal)', dial_code: '' },
  { code: 'SO', name: 'Somalia (Soomaaliya)', dial_code: '' },
  { code: 'SR', name: 'Suriname', dial_code: '' },
  { code: 'SS', name: 'South Sudan (‫جنوب السودان‬‎)', dial_code: '' },
  { code: 'ST', name: 'São Tomé and Príncipe', dial_code: '' },
  { code: 'SV', name: 'El Salvador', dial_code: '' },
  { code: 'SX', name: 'Sint Maarten', dial_code: '' },
  { code: 'SY', name: 'Syria (‫سوريا‬‎)', dial_code: '' },
  { code: 'SZ', name: 'Swaziland (Umbuso weSwatini)', dial_code: '' },
  { code: 'TA', name: 'Tristan da Cunha', dial_code: '' },
  { code: 'TC', name: 'Turks and Caicos Islands', dial_code: '' },
  { code: 'TD', name: 'Chad (Tchad)', dial_code: '' },
  { code: 'TG', name: 'Togo (République togolaise)', dial_code: '' },
  { code: 'TH', name: 'Thailand (ไทย)', dial_code: '' },
  { code: 'TJ', name: 'Tajikistan (Ҷумҳурии Тоҷикистон)', dial_code: '' },
  { code: 'TK', name: 'Tokelau', dial_code: '' },
  { code: 'TL', name: 'Timor-Leste (Timór-Leste)', dial_code: '' },
  { code: 'TM', name: 'Turkmenistan (Türkmenistan)', dial_code: '' },
  { code: 'TN', name: 'Tunisia (‫تونس‬‎)', dial_code: '' },
  { code: 'TO', name: 'Tonga', dial_code: '' },
  { code: 'TR', name: 'Turkey (Türkiye)', dial_code: '' },
  { code: 'TT', name: 'Trinidad and Tobago', dial_code: '' },
  { code: 'TV', name: 'Tuvalu', dial_code: '' },
  { code: 'TW', name: 'Taiwan (台灣)', dial_code: '' },
  { code: 'TZ', name: 'Tanzania', dial_code: '' },
  { code: 'UA', name: 'Ukraine (Україна)', dial_code: '' },
  { code: 'UG', name: 'Uganda', dial_code: '' },
  { code: 'US', name: 'United States', dial_code: '' },
  { code: 'UY', name: 'Uruguay', dial_code: '' },
  { code: 'UZ', name: 'Uzbekistan (Oʻzbekiston)', dial_code: '' },
  { code: 'VA', name: 'Vatican City (Città del Vaticano)', dial_code: '' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines', dial_code: '' },
  { code: 'VE', name: 'Venezuela', dial_code: '' },
  { code: 'VG', name: 'British Virgin Islands', dial_code: '' },
  { code: 'VI', name: 'U.S. Virgin Islands', dial_code: '' },
  { code: 'VN', name: 'Vietnam (Việt Nam)', dial_code: '' },
  { code: 'VU', name: 'Vanuatu', dial_code: '' },
  { code: 'WF', name: 'Wallis and Futuna (Wallis-et-Futuna)', dial_code: '' },
  { code: 'WS', name: 'Samoa (Sāmoa)', dial_code: '' },
  { code: 'XK', name: 'Kosovo', dial_code: '' },
  { code: 'YE', name: 'Yemen (‫اليمن‬‎)', dial_code: '' },
  { code: 'YT', name: 'Mayotte', dial_code: '' },
  { code: 'ZA', name: 'South Africa', dial_code: '' },
  { code: 'ZM', name: 'Zambia', dial_code: '' },
  { code: 'ZW', name: 'Zimbabwe', dial_code: '' },
  // Official code for the unknown region.
  { code: 'ZZ', name: 'International', dial_code: '' },
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/IntlTelephoneInput/CountriesList.ts